module.exports = __webpack_public_path__ + "img/logo.bb53cf5c.png";